import { themeSettings } from '../../js/settings';

let attributes = {
	block: null,
	isLoading: false,
	query: {
		paged: 1,
		postsLimit: 12,
	},
};

/**
 * Set Attributes.
 *
 * @param {object} newProps
 */
const setAttributes = ( newProps ) => {

	attributes = { ...attributes, ...newProps };

};

/**
 * Guides Fetch.
 *
 * @param {HTMLElement} block
 */
const guidesFetch = ( block ) => {

	setAttributes( { block } );
	setPostsLimit();
	loadMore();

};

/**
 * Set posts limit from template config.
 *
 * @return {void}
 */
const setPostsLimit = () => {

	const { block, query } = attributes;
	const postsLimit = parseInt( block.dataset.postsLimit || '12', 10 );
	query.postsLimit = Number.isNaN( postsLimit ) ? 12 : postsLimit;
	setAttributes( { query } );

};

/**
 * Load more init.
 *
 * @return {void}
 */
const loadMore = () => {

	const { block, query } = attributes;
	const loadMoreBtn = block.querySelector( '.js-guides-load-more' );
	if ( ! loadMoreBtn ) {

		return;

	}

	loadMoreBtn.addEventListener( 'click', ( e ) => {

		e.preventDefault();
		updateQuery( query.paged + 1 );

	} );

};

/**
 * Update query.
 *
 * @param {number} paged
 * @return {void}
 */
const updateQuery = ( paged = 1 ) => {

	const { query, isLoading } = attributes;
	if ( isLoading ) {

		return;

	}

	query.paged = paged;
	setAttributes( { query } );
	fetchGuides();

};

/**
 * Fetch guides.
 *
 * @return {void}
 */
const fetchGuides = () => {

	const { block, query, isLoading } = attributes;
	if ( isLoading ) {

		return;

	}

	setAttributes( { isLoading: true } );
	block.classList.add( 'is-loading' );

	const postsGrid = block.querySelector( '.js-guides-grid' );
	fetch( themeSettings.ajaxUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: new URLSearchParams( {
			action: 'getGuidesPostsAjax',
			bn: themeSettings.security,
			paged: query.paged,
			posts_limit: query.postsLimit,
		} ),
	} ).then( ( response ) => {

		return response.json();

	} ).then( ( response ) => {

		if ( query.paged === 1 || response.data.results === '' ) {

			postsGrid.innerHTML = '';

		}

		if ( response.data.results !== '' ) {

			postsGrid.insertAdjacentHTML( 'beforeend', response.data.results );

		}

		if ( response.data.lastPage ) {

			block.classList.add( 'is-loaded-all' );

		} else {

			block.classList.remove( 'is-loaded-all' );

		}

		block.classList.remove( 'is-loading' );
		setAttributes( { isLoading: false } );

	} ).catch( () => {

		block.classList.remove( 'is-loading' );
		setAttributes( { isLoading: false } );

	} );

};

export default guidesFetch;
